@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.merchants.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.merchants.generated.resources/"

internal val Res.string.feature_merchants_amount: StringResource by lazy {
      StringResource("string:feature_merchants_amount", "feature_merchants_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 40),
      ))
    }

internal val Res.string.feature_merchants_close: StringResource by lazy {
      StringResource("string:feature_merchants_close", "feature_merchants_close", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51, 39),
      ))
    }

internal val Res.string.feature_merchants_credits: StringResource by lazy {
      StringResource("string:feature_merchants_credits", "feature_merchants_credits", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 91, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91, 45),
      ))
    }

internal val Res.string.feature_merchants_debits: StringResource by lazy {
      StringResource("string:feature_merchants_debits", "feature_merchants_debits", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 133, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137, 40),
      ))
    }

internal val Res.string.feature_merchants_empty_no_merchants_subtitle: StringResource by lazy {
      StringResource("string:feature_merchants_empty_no_merchants_subtitle", "feature_merchants_empty_no_merchants_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 174, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178, 109),
      ))
    }

internal val Res.string.feature_merchants_empty_no_merchants_title: StringResource by lazy {
      StringResource("string:feature_merchants_empty_no_merchants_title", "feature_merchants_empty_no_merchants_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 292, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288, 98),
      ))
    }

internal val Res.string.feature_merchants_error_oops: StringResource by lazy {
      StringResource("string:feature_merchants_error_oops", "feature_merchants_error_oops", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 395, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 387, 44),
      ))
    }

internal val Res.string.feature_merchants_insufficient_balance: StringResource by lazy {
      StringResource("string:feature_merchants_insufficient_balance", "feature_merchants_insufficient_balance", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 440, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 432, 74),
      ))
    }

internal val Res.string.feature_merchants_loading: StringResource by lazy {
      StringResource("string:feature_merchants_loading", "feature_merchants_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 511, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 507, 45),
      ))
    }

internal val Res.string.feature_merchants_merchant_transaction: StringResource by lazy {
      StringResource("string:feature_merchants_merchant_transaction", "feature_merchants_merchant_transaction", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 557, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 553, 74),
      ))
    }

internal val Res.string.feature_merchants_no_transactions_found: StringResource by lazy {
      StringResource("string:feature_merchants_no_transactions_found", "feature_merchants_no_transactions_found", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 640, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 628, 75),
      ))
    }

internal val Res.string.feature_merchants_other: StringResource by lazy {
      StringResource("string:feature_merchants_other", "feature_merchants_other", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 732, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 704, 39),
      ))
    }

internal val Res.string.feature_merchants_search: StringResource by lazy {
      StringResource("string:feature_merchants_search", "feature_merchants_search", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 772, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 744, 40),
      ))
    }

internal val Res.string.feature_merchants_submit: StringResource by lazy {
      StringResource("string:feature_merchants_submit", "feature_merchants_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 813, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 785, 40),
      ))
    }

internal val Res.string.feature_merchants_transaction_date: StringResource by lazy {
      StringResource("string:feature_merchants_transaction_date", "feature_merchants_transaction_date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 854, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 826, 70),
      ))
    }

internal val Res.string.feature_merchants_transaction_id: StringResource by lazy {
      StringResource("string:feature_merchants_transaction_id", "feature_merchants_transaction_id", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 929, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 897, 64),
      ))
    }

internal val Res.string.feature_merchants_transfer_money_to_this_merchant: StringResource by lazy {
      StringResource("string:feature_merchants_transfer_money_to_this_merchant", "feature_merchants_transfer_money_to_this_merchant", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 998, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 962, 101),
      ))
    }

internal val Res.string.feature_merchants_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_merchants_unexpected_error_subtitle", "feature_merchants_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1100, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1064, 115),
      ))
    }

internal val Res.string.feature_merchants_vpa_copy_success: StringResource by lazy {
      StringResource("string:feature_merchants_vpa_copy_success", "feature_merchants_vpa_copy_success", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1236, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1180, 90),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_merchants_amount", Res.string.feature_merchants_amount)
  map.put("feature_merchants_close", Res.string.feature_merchants_close)
  map.put("feature_merchants_credits", Res.string.feature_merchants_credits)
  map.put("feature_merchants_debits", Res.string.feature_merchants_debits)
  map.put("feature_merchants_empty_no_merchants_subtitle", Res.string.feature_merchants_empty_no_merchants_subtitle)
  map.put("feature_merchants_empty_no_merchants_title", Res.string.feature_merchants_empty_no_merchants_title)
  map.put("feature_merchants_error_oops", Res.string.feature_merchants_error_oops)
  map.put("feature_merchants_insufficient_balance", Res.string.feature_merchants_insufficient_balance)
  map.put("feature_merchants_loading", Res.string.feature_merchants_loading)
  map.put("feature_merchants_merchant_transaction", Res.string.feature_merchants_merchant_transaction)
  map.put("feature_merchants_no_transactions_found", Res.string.feature_merchants_no_transactions_found)
  map.put("feature_merchants_other", Res.string.feature_merchants_other)
  map.put("feature_merchants_search", Res.string.feature_merchants_search)
  map.put("feature_merchants_submit", Res.string.feature_merchants_submit)
  map.put("feature_merchants_transaction_date", Res.string.feature_merchants_transaction_date)
  map.put("feature_merchants_transaction_id", Res.string.feature_merchants_transaction_id)
  map.put("feature_merchants_transfer_money_to_this_merchant", Res.string.feature_merchants_transfer_money_to_this_merchant)
  map.put("feature_merchants_unexpected_error_subtitle", Res.string.feature_merchants_unexpected_error_subtitle)
  map.put("feature_merchants_vpa_copy_success", Res.string.feature_merchants_vpa_copy_success)
}
